export default (field, value) => async (dispatch) => {
  dispatch({
    type: 'PAGES/CHANGE_FIELD',
    payload: { field, value },
  });
};
